import { memo } from 'react';
import {
    lineHeightStyle,
    styledComponent,
    isExistAnyUrologyExaminationData,
    defaultUrologyData
} from '../../../../utils/helpers';
import CommonDeleteBtn from '../commonDeleteBtn';
import biliarySystemImg from '../../../../assets/images/biliarySystem.png'
import digestiveSystemImg from '../../../../assets/images/digestiveSystem.png'

const UrologyExaminationView = ({
    prescriptionItems,
    selectedOnExamination,
    setSelectedOnExamination,
    isHistoryPage,
}) => {
    // Safely initialize urologyExamination with default empty object if undefined
    let { urologyExamination } = selectedOnExamination || {};
    urologyExamination = urologyExamination || {};

    const removeSpecificItemData = (field, subField) => {
        const updatedUrologyExamination = { ...urologyExamination };

        if (updatedUrologyExamination[field]) {
            updatedUrologyExamination[field] = {
                ...updatedUrologyExamination[field],
                [subField]: ''
            };

            // If both status and note are empty, reset the field to default
            if (!updatedUrologyExamination[field].status && !updatedUrologyExamination[field].note) {
                const defaults = defaultUrologyData();
                updatedUrologyExamination[field] = defaults && defaults[field] ? defaults[field] : { status: '', note: '' };
            }
        }

        setSelectedOnExamination({
            ...selectedOnExamination,
            urologyExamination: updatedUrologyExamination,
        });
    };

    const Title = styledComponent(
        prescriptionItems?.items?.['on-examination']?.itemStyle || {},
    );
    const Value = styledComponent(
        prescriptionItems?.items?.['on-examination']?.subItemStyle || {},
    );

    return (
        <>
            {isExistAnyUrologyExaminationData(urologyExamination) && (
                <>
                    {/* Digital Rectal Exam section */}
                    {((urologyExamination.analSensation && (urologyExamination.analSensation.status || urologyExamination.analSensation.note)) ||
                        (urologyExamination.analTone && (urologyExamination.analTone.status || urologyExamination.analTone.note)) ||
                        (urologyExamination.size && (urologyExamination.size.status || urologyExamination.size.note)) ||
                        (urologyExamination.consistency && (urologyExamination.consistency.status || urologyExamination.consistency.note)) ||
                        (urologyExamination.tenderness && (urologyExamination.tenderness.status || urologyExamination.tenderness.note)) ||
                        (urologyExamination.surface && (urologyExamination.surface.status || urologyExamination.surface.note)) ||
                        (urologyExamination.nodularity && (urologyExamination.nodularity.status || urologyExamination.nodularity.note)) ||
                        (urologyExamination.analMucosa && (urologyExamination.analMucosa.status || urologyExamination.analMucosa.note)) ||
                        (urologyExamination.upperBorder && (urologyExamination.upperBorder.status || urologyExamination.upperBorder.note)) ||
                        (urologyExamination.medianSulcus && (urologyExamination.medianSulcus.status || urologyExamination.medianSulcus.note))
                    ) && (
                            <div className="urology-sub-title">Digital Rectal Exam</div>
                        )}

                    <ul style={lineHeightStyle('on-examination', prescriptionItems)}>
                        {/* Anal Sensation */}
                        {urologyExamination.analSensation &&
                            (urologyExamination.analSensation.status || urologyExamination.analSensation.note) && (
                                <li className="text-left">
                                    <Title>Anal Sensation:</Title>{' '}
                                    {urologyExamination.analSensation.status && (
                                        <>
                                            <Value>
                                                {urologyExamination.analSensation.status}
                                                {urologyExamination.analSensation.note ? ': ' : ''}
                                            </Value>
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('analSensation', 'status')}
                                                    itemName="status"
                                                />
                                            )}
                                        </>
                                    )}
                                    {urologyExamination.analSensation.note && (
                                        <>
                                            {urologyExamination.analSensation.status ? (
                                                <>
                                                    <br />
                                                    <Value>- {urologyExamination.analSensation.note}</Value>
                                                </>
                                            ) : (
                                                <Value>{urologyExamination.analSensation.note}</Value>
                                            )}
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('analSensation', 'note')}
                                                    itemName="note"
                                                />
                                            )}
                                        </>
                                    )}
                                </li>
                            )}

                        {/* Anal Tone */}
                        {urologyExamination.analTone &&
                            (urologyExamination.analTone.status || urologyExamination.analTone.note) && (
                                <li className="text-left">
                                    <Title>Anal Tone:</Title>{' '}
                                    {urologyExamination.analTone.status && (
                                        <>
                                            <Value>
                                                {urologyExamination.analTone.status}
                                                {urologyExamination.analTone.note ? ' ' : ''}
                                            </Value>
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('analTone', 'status')}
                                                    itemName="status"
                                                />
                                            )}
                                        </>
                                    )}
                                    {urologyExamination.analTone.note && (
                                        <>
                                            {urologyExamination.analTone.status ? (
                                                <>
                                                    <br />
                                                    <Value>- {urologyExamination.analTone.note}</Value>
                                                </>
                                            ) : (
                                                <Value>{urologyExamination.analTone.note}</Value>
                                            )}
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('analTone', 'note')}
                                                    itemName="note"
                                                />
                                            )}
                                        </>
                                    )}
                                </li>
                            )}

                        {/* Size */}
                        {urologyExamination.size &&
                            (urologyExamination.size.status || urologyExamination.size.note) && (
                                <li className="text-left">
                                    <Title>Prostate Size:</Title>{' '}
                                    {urologyExamination.size.status && (
                                        <>
                                            <Value>
                                                {urologyExamination.size.status}
                                                {urologyExamination.size.note ? ' ' : ''}
                                            </Value>
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('size', 'status')}
                                                    itemName="status"
                                                />
                                            )}
                                        </>
                                    )}
                                    {urologyExamination.size.note && (
                                        <>
                                            {urologyExamination.size.status ? (
                                                <>
                                                    <br />
                                                    <Value>- {urologyExamination.size.note}</Value>
                                                </>
                                            ) : (
                                                <Value>{urologyExamination.size.note}</Value>
                                            )}
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('size', 'note')}
                                                    itemName="note"
                                                />
                                            )}
                                        </>
                                    )}
                                </li>
                            )}

                        {/* Consistency */}
                        {urologyExamination.consistency &&
                            (urologyExamination.consistency.status || urologyExamination.consistency.note) && (
                                <li className="text-left">
                                    <Title>Prostate Consistency:</Title>{' '}
                                    {urologyExamination.consistency.status && (
                                        <>
                                            <Value>
                                                {urologyExamination.consistency.status}
                                                {urologyExamination.consistency.note ? ' ' : ''}
                                            </Value>
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('consistency', 'status')}
                                                    itemName="status"
                                                />
                                            )}
                                        </>
                                    )}
                                    {urologyExamination.consistency.note && (
                                        <>
                                            {urologyExamination.consistency.status ? (
                                                <>
                                                    <br />
                                                    <Value>- {urologyExamination.consistency.note}</Value>
                                                </>
                                            ) : (
                                                <Value>{urologyExamination.consistency.note}</Value>
                                            )}
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('consistency', 'note')}
                                                    itemName="note"
                                                />
                                            )}
                                        </>
                                    )}
                                </li>
                            )}

                        {/* Tenderness */}
                        {urologyExamination.tenderness &&
                            (urologyExamination.tenderness.status || urologyExamination.tenderness.note) && (
                                <li className="text-left">
                                    <Title>Tenderness:</Title>{' '}
                                    {urologyExamination.tenderness.status && (
                                        <>
                                            <Value>
                                                {urologyExamination.tenderness.status}
                                                {urologyExamination.tenderness.note ? ' ' : ''}
                                            </Value>
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('tenderness', 'status')}
                                                    itemName="status"
                                                />
                                            )}
                                        </>
                                    )}
                                    {urologyExamination.tenderness.note && (
                                        <>
                                            {urologyExamination.tenderness.status ? (
                                                <>
                                                    <br />
                                                    <Value>- {urologyExamination.tenderness.note}</Value>
                                                </>
                                            ) : (
                                                <Value>{urologyExamination.tenderness.note}</Value>
                                            )}
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('tenderness', 'note')}
                                                    itemName="note"
                                                />
                                            )}
                                        </>
                                    )}
                                </li>
                            )}

                        {/* Surface */}
                        {urologyExamination.surface &&
                            (urologyExamination.surface.status || urologyExamination.surface.note) && (
                                <li className="text-left">
                                    <Title>Surface:</Title>{' '}
                                    {urologyExamination.surface.status && (
                                        <>
                                            <Value>
                                                {urologyExamination.surface.status}
                                                {urologyExamination.surface.note ? ' ' : ''}
                                            </Value>
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('surface', 'status')}
                                                    itemName="status"
                                                />
                                            )}
                                        </>
                                    )}
                                    {urologyExamination.surface.note && (
                                        <>
                                            {urologyExamination.surface.status ? (
                                                <>
                                                    <br />
                                                    <Value>- {urologyExamination.surface.note}</Value>
                                                </>
                                            ) : (
                                                <Value>{urologyExamination.surface.note}</Value>
                                            )}
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('surface', 'note')}
                                                    itemName="note"
                                                />
                                            )}
                                        </>
                                    )}
                                </li>
                            )}

                        {/* Nodularity */}
                        {urologyExamination.nodularity &&
                            (urologyExamination.nodularity.status || urologyExamination.nodularity.note) && (
                                <li className="text-left">
                                    <Title>Nodularity:</Title>{' '}
                                    {urologyExamination.nodularity.status && (
                                        <>
                                            <Value>
                                                {urologyExamination.nodularity.status}
                                                {urologyExamination.nodularity.note ? ' ' : ''}
                                            </Value>
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('nodularity', 'status')}
                                                    itemName="status"
                                                />
                                            )}
                                        </>
                                    )}
                                    {urologyExamination.nodularity.note && (
                                        <>
                                            {urologyExamination.nodularity.status ? (
                                                <>
                                                    <br />
                                                    <Value>- {urologyExamination.nodularity.note}</Value>
                                                </>
                                            ) : (
                                                <Value>{urologyExamination.nodularity.note}</Value>
                                            )}
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('nodularity', 'note')}
                                                    itemName="note"
                                                />
                                            )}
                                        </>
                                    )}
                                </li>
                            )}

                        {/* Anal Mucosa */}
                        {urologyExamination.analMucosa &&
                            (urologyExamination.analMucosa.status || urologyExamination.analMucosa.note) && (
                                <li className="text-left">
                                    <Title>Anal Mucosa:</Title>{' '}
                                    {urologyExamination.analMucosa.status && (
                                        <>
                                            <Value>
                                                {urologyExamination.analMucosa.status}
                                                {urologyExamination.analMucosa.note ? ' ' : ''}
                                            </Value>
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('analMucosa', 'status')}
                                                    itemName="status"
                                                />
                                            )}
                                        </>
                                    )}
                                    {urologyExamination.analMucosa.note && (
                                        <>
                                            {urologyExamination.analMucosa.status ? (
                                                <>
                                                    <br />
                                                    <Value>- {urologyExamination.analMucosa.note}</Value>
                                                </>
                                            ) : (
                                                <Value>{urologyExamination.analMucosa.note}</Value>
                                            )}
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('analMucosa', 'note')}
                                                    itemName="note"
                                                />
                                            )}
                                        </>
                                    )}
                                </li>
                            )}

                        {/* Upper Border */}
                        {urologyExamination.upperBorder &&
                            (urologyExamination.upperBorder.status || urologyExamination.upperBorder.note) && (
                                <li className="text-left">
                                    <Title>Upper Border:</Title>{' '}
                                    {urologyExamination.upperBorder.status && (
                                        <>
                                            <Value>
                                                {urologyExamination.upperBorder.status}
                                                {urologyExamination.upperBorder.note ? ' ' : ''}
                                            </Value>
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('upperBorder', 'status')}
                                                    itemName="status"
                                                />
                                            )}
                                        </>
                                    )}
                                    {urologyExamination.upperBorder.note && (
                                        <>
                                            {urologyExamination.upperBorder.status ? (
                                                <>
                                                    <br />
                                                    <Value>- {urologyExamination.upperBorder.note}</Value>
                                                </>
                                            ) : (
                                                <Value>{urologyExamination.upperBorder.note}</Value>
                                            )}
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('upperBorder', 'note')}
                                                    itemName="note"
                                                />
                                            )}
                                        </>
                                    )}
                                </li>
                            )}

                        {/* Median Sulcus */}
                        {urologyExamination.medianSulcus &&
                            (urologyExamination.medianSulcus.status || urologyExamination.medianSulcus.note) && (
                                <li className="text-left">
                                    <Title>Median Sulcus:</Title>{' '}
                                    {urologyExamination.medianSulcus.status && (
                                        <>
                                            <Value>
                                                {urologyExamination.medianSulcus.status}
                                                {urologyExamination.medianSulcus.note ? ' ' : ''}
                                            </Value>
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('medianSulcus', 'status')}
                                                    itemName="status"
                                                />
                                            )}
                                        </>
                                    )}
                                    {urologyExamination.medianSulcus.note && (
                                        <>
                                            {urologyExamination.medianSulcus.status ? (
                                                <>
                                                    <br />
                                                    <Value>- {urologyExamination.medianSulcus.note}</Value>
                                                </>
                                            ) : (
                                                <Value>{urologyExamination.medianSulcus.note}</Value>
                                            )}
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('medianSulcus', 'note')}
                                                    itemName="note"
                                                />
                                            )}
                                        </>
                                    )}
                                </li>
                            )}
                    </ul>

                    {/* External Genitalia section header */}
                    {((urologyExamination.eum && (urologyExamination.eum.status || urologyExamination.eum.note)) ||
                        (urologyExamination.phallus && (urologyExamination.phallus.status || urologyExamination.phallus.note)) ||
                        (urologyExamination.antUrethra && (urologyExamination.antUrethra.status || urologyExamination.antUrethra.note)) ||
                        (urologyExamination.scrutum && (urologyExamination.scrutum.status || urologyExamination.scrutum.note)) ||
                        (urologyExamination.testes && (urologyExamination.testes.status || urologyExamination.testes.note)) ||
                        (urologyExamination.epididymis && (urologyExamination.epididymis.status || urologyExamination.epididymis.note)) ||
                        (urologyExamination.vas && (urologyExamination.vas.status || urologyExamination.vas.note)) ||
                        (urologyExamination.pampiniformPlexus && (urologyExamination.pampiniformPlexus.status || urologyExamination.pampiniformPlexus.note))) && (
                            <div className="urology-sub-title">External Genitalia</div>
                        )}
                    <ul style={lineHeightStyle('on-examination', prescriptionItems)}>
                        {/* EUM */}
                        {urologyExamination.eum &&
                            (urologyExamination.eum.status || urologyExamination.eum.note) && (
                                <li className="text-left">
                                    <Title>EUM:</Title>{' '}
                                    {urologyExamination.eum.status && (
                                        <>
                                            <Value>
                                                {urologyExamination.eum.status}
                                                {urologyExamination.eum.note ? ' ' : ''}
                                            </Value>
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('eum', 'status')}
                                                    itemName="status"
                                                />
                                            )}
                                        </>
                                    )}
                                    {urologyExamination.eum.note && (
                                        <>
                                            {urologyExamination.eum.status ? (
                                                <>
                                                    <br />
                                                    <Value>- {urologyExamination.eum.note}</Value>
                                                </>
                                            ) : (
                                                <Value>{urologyExamination.eum.note}</Value>
                                            )}
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('eum', 'note')}
                                                    itemName="note"
                                                />
                                            )}
                                        </>
                                    )}
                                </li>
                            )}

                        {/* Phallus */}
                        {urologyExamination.phallus &&
                            (urologyExamination.phallus.status || urologyExamination.phallus.note) && (
                                <li className="text-left">
                                    <Title>Phallus:</Title>{' '}
                                    {urologyExamination.phallus.status && (
                                        <>
                                            <Value>
                                                {urologyExamination.phallus.status}
                                                {urologyExamination.phallus.note ? ' ' : ''}
                                            </Value>
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('phallus', 'status')}
                                                    itemName="status"
                                                />
                                            )}
                                        </>
                                    )}
                                    {urologyExamination.phallus.note && (
                                        <>
                                            {urologyExamination.phallus.status ? (
                                                <>
                                                    <br />
                                                    <Value>- {urologyExamination.phallus.note}</Value>
                                                </>
                                            ) : (
                                                <Value>{urologyExamination.phallus.note}</Value>
                                            )}
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('phallus', 'note')}
                                                    itemName="note"
                                                />
                                            )}
                                        </>
                                    )}
                                </li>
                            )}

                        {/* Ant Urethra */}
                        {urologyExamination.antUrethra &&
                            (urologyExamination.antUrethra.status || urologyExamination.antUrethra.note) && (
                                <li className="text-left">
                                    <Title>Ant Urethra:</Title>{' '}
                                    {urologyExamination.antUrethra.status && (
                                        <>
                                            <Value>
                                                {urologyExamination.antUrethra.status}
                                                {urologyExamination.antUrethra.note ? ' ' : ''}
                                            </Value>
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('antUrethra', 'status')}
                                                    itemName="status"
                                                />
                                            )}
                                        </>
                                    )}
                                    {urologyExamination.antUrethra.note && (
                                        <>
                                            {urologyExamination.antUrethra.status ? (
                                                <>
                                                    <br />
                                                    <Value>- {urologyExamination.antUrethra.note}</Value>
                                                </>
                                            ) : (
                                                <Value>{urologyExamination.antUrethra.note}</Value>
                                            )}
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('antUrethra', 'note')}
                                                    itemName="note"
                                                />
                                            )}
                                        </>
                                    )}
                                </li>
                            )}

                        {/* Scrutum */}
                        {urologyExamination.scrutum &&
                            (urologyExamination.scrutum.status || urologyExamination.scrutum.note) && (
                                <li className="text-left">
                                    <Title>Scrutum:</Title>{' '}
                                    {urologyExamination.scrutum.status && (
                                        <>
                                            <Value>
                                                {urologyExamination.scrutum.status}
                                                {urologyExamination.scrutum.note ? ' ' : ''}
                                            </Value>
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('scrutum', 'status')}
                                                    itemName="status"
                                                />
                                            )}
                                        </>
                                    )}
                                    {urologyExamination.scrutum.note && (
                                        <>
                                            {urologyExamination.scrutum.status ? (
                                                <>
                                                    <br />
                                                    <Value>- {urologyExamination.scrutum.note}</Value>
                                                </>
                                            ) : (
                                                <Value>{urologyExamination.scrutum.note}</Value>
                                            )}
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('scrutum', 'note')}
                                                    itemName="note"
                                                />
                                            )}
                                        </>
                                    )}
                                </li>
                            )}

                        {/* Testes */}
                        {urologyExamination.testes &&
                            (urologyExamination.testes.status || urologyExamination.testes.note) && (
                                <li className="text-left">
                                    <Title>Testes:</Title>{' '}
                                    {urologyExamination.testes.status && (
                                        <>
                                            <Value>
                                                {urologyExamination.testes.status}
                                                {urologyExamination.testes.note ? ' ' : ''}
                                            </Value>
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('testes', 'status')}
                                                    itemName="status"
                                                />
                                            )}
                                        </>
                                    )}
                                    {urologyExamination.testes.note && (
                                        <>
                                            {urologyExamination.testes.status ? (
                                                <>
                                                    <br />
                                                    <Value>- {urologyExamination.testes.note}</Value>
                                                </>
                                            ) : (
                                                <Value>{urologyExamination.testes.note}</Value>
                                            )}
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('testes', 'note')}
                                                    itemName="note"
                                                />
                                            )}
                                        </>
                                    )}
                                </li>
                            )}

                        {/* Epididymis */}
                        {urologyExamination.epididymis &&
                            (urologyExamination.epididymis.status || urologyExamination.epididymis.note) && (
                                <li className="text-left">
                                    <Title>Epididymis:</Title>{' '}
                                    {urologyExamination.epididymis.status && (
                                        <>
                                            <Value>
                                                {urologyExamination.epididymis.status}
                                                {urologyExamination.epididymis.note ? ' ' : ''}
                                            </Value>
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('epididymis', 'status')}
                                                    itemName="status"
                                                />
                                            )}
                                        </>
                                    )}
                                    {urologyExamination.epididymis.note && (
                                        <>
                                            {urologyExamination.epididymis.status ? (
                                                <>
                                                    <br />
                                                    <Value>- {urologyExamination.epididymis.note}</Value>
                                                </>
                                            ) : (
                                                <Value>{urologyExamination.epididymis.note}</Value>
                                            )}
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('epididymis', 'note')}
                                                    itemName="note"
                                                />
                                            )}
                                        </>
                                    )}
                                </li>
                            )}

                        {/* Vas */}
                        {urologyExamination.vas &&
                            (urologyExamination.vas.status || urologyExamination.vas.note) && (
                                <li className="text-left">
                                    <Title>Vas:</Title>{' '}
                                    {urologyExamination.vas.status && (
                                        <>
                                            <Value>
                                                {urologyExamination.vas.status}
                                                {urologyExamination.vas.note ? ' ' : ''}
                                            </Value>
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('vas', 'status')}
                                                    itemName="status"
                                                />
                                            )}
                                        </>
                                    )}
                                    {urologyExamination.vas.note && (
                                        <>
                                            {urologyExamination.vas.status ? (
                                                <>
                                                    <br />
                                                    <Value>- {urologyExamination.vas.note}</Value>
                                                </>
                                            ) : (
                                                <Value>{urologyExamination.vas.note}</Value>
                                            )}
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('vas', 'note')}
                                                    itemName="note"
                                                />
                                            )}
                                        </>
                                    )}
                                </li>
                            )}
                        {/* Pampiniform Plexus */}
                        {urologyExamination.pampiniformPlexus &&
                            (urologyExamination.pampiniformPlexus.status || urologyExamination.pampiniformPlexus.note) && (
                                <li className="text-left">
                                    <Title>Pampiniform Plexus:</Title>{' '}
                                    {urologyExamination.pampiniformPlexus.status && (
                                        <>
                                            <Value>
                                                {urologyExamination.pampiniformPlexus.status}
                                                {urologyExamination.pampiniformPlexus.note ? ' ' : ''}
                                            </Value>
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('pampiniformPlexus', 'status')}
                                                    itemName="status"
                                                />
                                            )}
                                        </>
                                    )}
                                    {urologyExamination.pampiniformPlexus.note && (
                                        <>
                                            {urologyExamination.pampiniformPlexus.status ? (
                                                <>
                                                    <br />
                                                    <Value>- {urologyExamination.pampiniformPlexus.note}</Value>
                                                </>
                                            ) : (
                                                <Value>{urologyExamination.pampiniformPlexus.note}</Value>
                                            )}
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('pampiniformPlexus', 'note')}
                                                    itemName="note"
                                                />
                                            )}
                                        </>
                                    )}
                                </li>
                            )}

                        {/* Show Biliary System Picture */}
                        {urologyExamination.showBiliaryPicture &&
                            (urologyExamination.showBiliaryPicture.status || urologyExamination.showBiliaryPicture.note) && (
                                <li className="text-left">
                                    <Title>Biliary System:</Title>{' '}
                                    {urologyExamination.showBiliaryPicture.status && (
                                        <>
                                            <div>
                                                <img src={biliarySystemImg} height={160} width={200} alt="Biliary System" />
                                                {!isHistoryPage && (
                                                    <CommonDeleteBtn
                                                        action={() => removeSpecificItemData('showBiliaryPicture', 'status')}
                                                        itemName="image"
                                                    />
                                                )}
                                            </div>
                                        </>
                                    )}
                                    {urologyExamination.showBiliaryPicture.note && (
                                        <>
                                            {urologyExamination.showBiliaryPicture.status ? (
                                                <>
                                                    <br />
                                                    <Value>- {urologyExamination.showBiliaryPicture.note}</Value>
                                                </>
                                            ) : (
                                                <Value>{urologyExamination.showBiliaryPicture.note}</Value>
                                            )}
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('showBiliaryPicture', 'note')}
                                                    itemName="note"
                                                />
                                            )}
                                        </>
                                    )}
                                </li>
                            )}


                        {/* Show Digestive System Picture */}
                        {urologyExamination.showDigestivePicture &&
                            (urologyExamination.showDigestivePicture.status || urologyExamination.showDigestivePicture.note) && (
                                <li className="text-left">
                                    <Title>Digestive System:</Title>{' '}
                                    {urologyExamination.showDigestivePicture.status && (
                                        <>
                                            <div>
                                                <img src={digestiveSystemImg} height={250} width={200} alt="Digestive System" />
                                                {!isHistoryPage && (
                                                    <CommonDeleteBtn
                                                        action={() => removeSpecificItemData('showDigestivePicture', 'status')}
                                                        itemName="image"
                                                    />
                                                )}
                                            </div>
                                        </>
                                    )}
                                    {urologyExamination.showDigestivePicture.note && (
                                        <>
                                            {urologyExamination.showDigestivePicture.status ? (
                                                <>
                                                    <br />
                                                    <Value>- {urologyExamination.showDigestivePicture.note}</Value>
                                                </>
                                            ) : (
                                                <Value>{urologyExamination.showDigestivePicture.note}</Value>
                                            )}
                                            {!isHistoryPage && (
                                                <CommonDeleteBtn
                                                    action={() => removeSpecificItemData('showDigestivePicture', 'note')}
                                                    itemName="note"
                                                />
                                            )}
                                        </>
                                    )}
                                </li>
                            )}
                    </ul>
                </>
            )}
        </>
    );
};

export default memo(UrologyExaminationView);